import React, { useCallback, useEffect, useState } from "react";
import {getData, postData, postFormData} from '../middleware/apiMiddleware';
import s from './SchoolCreateUsers.module.css';
import { useNavigate } from "react-router-dom";
import {RedButton, GreenButton, BlueButton} from './MyButton';
import {modifiedDate} from '../middleware/dateControl';

import MyTooltip from '../components/Utilities/MyTooltip';

import MyComponentLoading from '../components/Utilities/MyComponentLoading';

export default function SchoolCreateUsers(prop) {	
	const navigate = useNavigate();
	
	let orgId = prop.schoolId;
	let triggerAfterCreate = prop.triggerAfterCreate;
	let userGroup = prop.userGroup;
	const [fetchCompleted, setFetchCompleted] = useState(true);
	const [data, setData] = useState([]);
	const [errorMessage, setErrorMessage] = useState("")
	const [usernameStr, setUsernameStr] = useState("");

	const [userObjs, setUserObjs] = useState([]);
	const [invalidUserCnt, setInvalidUserCnt] = useState(0);
	
	const [cStep, setCStep] = useState(1);
	
	const loadUsername = async () => {		
		let newUsername = usernameStr.trim().split(/\r\n|\n|\r/);
		if (newUsername.length == 0) {
			return;
		}
		
		let tmpInvalidUserCnt = 0;
		
		let hasDuplicate = false;
		let duplicateUserName = [];
		let existingName = [];
		for(let nc of newUsername) {
			if (existingName.includes(nc)) {
				hasDuplicate = true;
				duplicateUserName.push(nc);
			} else {
				existingName.push(nc);
			}
		}
		if (hasDuplicate) {
			setErrorMessage("Duplicate User name " + duplicateUserName);
			return;
		}
		
		let obj = { names:newUsername }
		
		let res = await postData("schoolApi/getUserByUsernames", obj, navigate); 
		let data = res.data;
		let nameMap = [];
		for(let d of data) {
			if (d.orgIds.includes(orgId)) {
				d.isCOrg = true;
			} else {
				d.isCOrg = false;
			}
			
			nameMap[d.username.toLowerCase()] = d;
		}
		
		let tmpUserObjs = [];
		for(let un of newUsername) {
			let o = {
				id:null,
				username:un,
				nickname:null,
				isCOrg:false,		
				orgIds:[]				
			}
			
			let lun = un.toLowerCase();
			if (nameMap[lun]) {
				o.id = nameMap[lun].id;
				o.nickname = nameMap[lun].nickname;
				o.isCOrg = nameMap[lun].isCOrg;
				o.orgIds = nameMap[lun].orgIds;
			}
			
			if (o.id && !o.isCOrg) {
				tmpInvalidUserCnt++;
			}
			
			tmpUserObjs.push(o);
		}
		setInvalidUserCnt(tmpInvalidUserCnt);
		setUserObjs(tmpUserObjs);
		setCStep(2);
	}
	
	const [nicknameStr, setNicknameStr] = useState("");
	const loadNickname = async () => {		
		let newNickname = nicknameStr.split(/\r\n|\n|\r/);
		if (newNickname.length == 0) {
			return;
		}
		
		if (userObjs.length > newNickname.length) {
			return;
		}
		
		for(let i = 0; i < userObjs.length; i++) {
			userObjs[i].nickname = newNickname[i];
		}
		
		setUserObjs([...userObjs]);
	}
	
	const [isBinding, setIsBinding] = useState(false);
	
	const createAndBindUserToOrganization = async () => {
		setIsBinding(true);
		
		
		let obj = { userObjs:userObjs.filter(u=>(!u.id)), userGroup, orgId}
		
		if (obj.userObjs.length>0) {
			await postData("schoolApi/createAndBindUserToOrganization", obj, navigate); 
		}
		setIsBinding(false);
		setCStep(1)
		setUsernameStr("")
		setNicknameStr("")
		setUserObjs([])
		triggerAfterCreate();
	}
	
	/*
	const fetchData = async () => {
		getData('item/listAll?itemId=' + itemId, navigate)
		.then(res => {
				setData(res.data);			
			
				setFetchCompleted(true);
			}
		);
	}*/
	useEffect(() => {
		
	}, []);
	
	if (!fetchCompleted || isBinding) {
		return (<MyComponentLoading />)
	}
	
	return (<div className={s.mainHolder}>
		
		<div className={s.paramHolder}>
			<div className={s.newLabel} style={{overflowWrap: "break-word"}}>{errorMessage}</div>
				{(cStep > 2) && (<div style={{position:"absolute", top:"20px"}}><BlueButton isEnabled={true}
				clickedAction={()=>{
					if (cStep > 2) {
						setCStep(cStep - 1);
					}
				}} bText='BACK' 
				/> </div>)
				}
			{
				(cStep <=2) && (
					<div style={{margin:"10px 0"}}>
						<div style={{fontWeight:"bold", fontSize:"22px"}}>Step 1 - Load all usernames</div>
						
						<div style={{display:"flex", flexWrap:"wrap", alignContent:"center", alignItems:"center", justifyContent:"center"}}>
							<textarea style={{border:"1px solid #22222222", minWidth:"200px"}}  
								className={s.textAreaAuto} value={usernameStr} rows={5} wrap='off' onChange={(e) => setUsernameStr(e.target.value)}/>
							
							<div style={{margin:"20px", display:"flex", flexDirection:"column"}}>
								<div style={{fontSize:"16px", width:"250px"}}>Copy and paste all usernames to the left panel, line by line, and then press <span style={{fontWeight:"1000"}}>Load</span>.</div>
								<BlueButton isEnabled={usernameStr}
									clickedAction={()=>{
										loadUsername();
									}} bText="Load" />
							
							</div>
						</div>
					</div>)			
			}
			{
				(cStep == 2) && (
					<div style={{margin:"10px 0"}}>
						<div style={{fontWeight:"bold", fontSize:"22px", borderTop:"2px solid #867a55"}}>Step 1.5 - Load Info</div>
						
						<div style={{display:"flex", flexWrap:"wrap", alignContent:"center", alignItems:"center", justifyContent:"center"}}>
							<div>
								<div>Nickname</div>
								<textarea style={{border:"1px solid #22222222", minWidth:"200px"}}  
									className={s.textAreaAuto} value={nicknameStr} rows={5} wrap='off' onChange={(e) => setNicknameStr(e.target.value)}/>
							</div>
							<div style={{margin:"20px", display:"flex", flexDirection:"column"}}>
								<BlueButton isEnabled={nicknameStr}
									clickedAction={()=>{
										loadNickname();
									}} bText="Load" />
							
							</div>
						</div>
					</div>)		
			}
			
			{
				(cStep == 2) && (
					<div style={{margin:"10px 0"}}>
						<div style={{fontWeight:"bold", fontSize:"22px", borderTop:"2px solid #867a55"}}>Step 2 - Review User</div>
							{(invalidUserCnt > 0) && (<div style={{fontWeight:"bold", color:"red"}}>Invalid User Count : {invalidUserCnt}</div>)}
							{(invalidUserCnt == 0) && (<div style={{display:"flex", flexDirection:"row", justifyContent:"center"}}>
								<div style={{display:"flex", flexDirection:"column", justifyContent:"center", border:"3px solid green", padding:"5px"}}>
									<div style={{fontWeight:"bold", color:"green"}}>Valid! You may create and bind acc to this school</div>
									<div>
										<GreenButton isEnabled={true}
											clickedAction={()=>{
												createAndBindUserToOrganization();
											}} bText="Create" />
									</div>
									</div>
								</div>
							)}
							{userObjs.map((u, indexU)=>(<div key={indexU} style={{textAlign:"left", display:"flex", padding:"0 5px", borderRadius:"5px", border: (u.id && !u.isCOrg) ? "2px solid red": "", margin:"2px 0"}}>
								<div style={{flexBasis: "100px"}}>{u.id}</div>
								<div style={{flexBasis: "200px"}}>{u.username}</div>
								<div style={{flexBasis: "200px"}}>{u.nickname}</div>
								<div style={{flexBasis: "100px"}}>{u.orgIds.toString()}</div>
							</div>))}
				</div>)		
			}
		</div>
	</div>);
	
}

